// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__2bDMD"};